module.exports = __webpack_public_path__ + "static/surfers-against-sewage-hhite-fabdf95e8002cf56b684c0f47f577f3a.png";